import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-confirm-register-issuer-acc-popup',
    templateUrl: './confirm-register-issuer-acc-popup.component.html',
    styleUrls: ['./confirm-register-issuer-acc-popup.component.scss'],
    standalone: false
})
export class ConfirmRegisterIssuerAccPopupComponent {
  constructor(public activeModal: NgbActiveModal) {}

  stay() {
    this.activeModal.dismiss('stay'); // user chooses to stay
  }

  proceed() {
    this.activeModal.close('confirm'); // user confirms action
  }
}
